<template>
  <div class="editor-paragraph" v-html="data.text"></div>
</template>

<script>
  import Base from '@/components/editorjs/Base';

  export default {
    name: 'Paragraph',
    extends: Base,
  };
</script>
<style lang="scss">
  @import 'src/styles/components/editorjs';
</style>
